import { FieldValueChangedArgs } from './../field-value-changed-args';
import { ModuleStructure } from './../../models/module-structure';
import { RecordModel } from 'src/app/layout/record-model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModuleInformation } from 'src/app/models/module-information';
import { LayoutService } from '../layout.service';
import { Title } from '@angular/platform-browser';
import * as g from 'src/app/globals';
import { RecordModelQueue } from 'src/app/models/record-model-queue';

@Component({
  selector: 'app-module-list-new',
  templateUrl: './module-list-new.component.html',
  styleUrls: ['./module-list-new.component.less'],
})
export class ModuleListNewComponent implements OnInit, OnDestroy {
  NaN = NaN;
  recordPageInit = true;
  selectedRecords: any[] = [];
  selectedRecordsFromCheckBox: string[] = [];
  moduleIdVal: string;
  objectDescription = '';
  newMode = false;
  moduleStructure: ModuleStructure;
  openedObjects: RecordModelQueue[] = [];
  pageHeaderAffix: boolean;
  recordModel: RecordModel;
  guid: string;

  set moduleId(value: string) {
    this.moduleIdVal = value;
  }
  get moduleId(): string {
    return this.moduleIdVal;
  }

  moduleFilterId = 0;
  sourceModuleId = '0';

  app = '';
  urlPrefix = '';

  db: IDBDatabase;
  moduleInformation: ModuleInformation;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    private title: Title
  ) {}

  ngOnDestroy(): void {
    this.layoutService.containerTransparentBGEmitter.emit(false);
    this.layoutService.containerFooterLeftPaddingEmitter.emit(0);
    this.title.setTitle(g.getTitleSuffix());
  }

  ngOnInit(): void {
    this.layoutService.containerTransparentBGEmitter.emit(true);
    this.layoutService.containerFooterLeftPaddingEmitter.emit(12.5);

    this.layoutService.fieldValueChanged.subscribe((args) => {
      this.valueChanged(args);
    });

    this.app = this.route.snapshot.data.app;
    if (g.currentAppPrefix === '') {
      this.urlPrefix = `/apps/${this.app}/module-list-new/`;
    } else {
      this.urlPrefix = g.currentAppPrefix + 'module-list-new/';
    }

    this.route.params.subscribe((data) => {
      this.guid = data.guid;
      this.layoutService
        .moduleInformation(data.moduleId)
        .subscribe((d: ModuleInformation) => {
          if (this.moduleId !== data.moduleId) {
            this.moduleId = undefined;
          }

          setTimeout(() => {
            if (this.moduleId !== data.moduleId) {
              this.selectedRecordsFromCheckBox = [];
              this.layoutService
                .getModuleStructure(data.moduleId)
                .subscribe((moduleStructure) => {
                  this.moduleStructure = moduleStructure;
                });
            }

            this.moduleId = data.moduleId;
            this.moduleFilterId = data.moduleFilterId;
            this.newMode = data.newMode === 'true';
            if (data.selectedId === undefined) {
              this.recordSelected([]);
            } else {
              this.recordSelected([data.selectedId], false);
            }

            this.moduleInformation = d;
            if (this.newMode) {
              this.title.setTitle(
                `${
                  this.moduleInformation.CreateNewText
                } - ${g.getTitleSuffix()}`
              );
            } else {
              this.title.setTitle(
                `${this.moduleInformation.PluralName} - ${g.getTitleSuffix()}`
              );
            }
          }, 10);
        });
    });

    this.prepareData();
  }

  prepareData() {
    const request = indexedDB.open(
      `${g.userIdentity.UserCode}-${g.userIdentity.CompanyDB}`,
      3
    );

    request.onupgradeneeded = () => {
      this.db = request.result;
      this.db.createObjectStore('RecordModelQueue', { keyPath: 'guid' });
    };

    request.onsuccess = () => {
      this.db = request.result;
      this.readRecordModelQueue();
    };
  }

  readRecordModelQueue() {
    const transaction = this.db.transaction('RecordModelQueue', 'readonly');
    const store = transaction.objectStore('RecordModelQueue');
    const reader = store.getAll();
    reader.onsuccess = () => {
      this.openedObjects = reader.result;
    };
  }

  recordSelected(selection: any[], setNewMode?): void {
    if (selection === undefined) {
      return;
    }

    this.objectDescription = '';
    this.selectedRecords = selection;
    if (
      selection[0] === undefined ||
      selection === undefined ||
      selection.length === 0
    ) {
      this.selectedRecords = [];
      this.openedObjects.forEach((e) => {
        if (e.selected === false) {
          return;
        } else {
          e.selected = false;
          this.addUpdateRecordModelQueue(e);
        }
      });

      if (this.newMode || setNewMode === true) {
        this.recordPageInit = false;
        setTimeout(() => {
          this.router.navigate([
            `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
            { newMode: true },
          ]);
          this.recordPageInit = true;
        }, 100);
      } else {
        this.router.navigate([
          `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
        ]);
      }
    } else {
      this.recordPageInit = false;
      this.openedObjects.forEach((e) => {
        if (e.selected === false) {
          return;
        } else {
          e.selected = false;
          this.addUpdateRecordModelQueue(e);
        }
      });

      if (this.guid != null) {
        const openedObject = this.openedObjects.find(
          (a) => a.guid === this.guid
        );

        if (openedObject == null) {
          this.guid = null;
        } else {
          this.recordModel = openedObject.recordModel;
          openedObject.selected = true;

          this.addUpdateRecordModelQueue(openedObject);
        }
      } else {
        this.recordModel = undefined;
      }

      setTimeout(() => {
        if (this.guid != null) {
          this.router.navigate([
            `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
            {
              selectedId: this.selectedRecords[0],
              guid: this.guid,
            },
          ]);
        } else {
          this.router.navigate([
            `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
            {
              selectedId: this.selectedRecords[0],
            },
          ]);

          let openedObject = this.openedObjects.find(
            (a) =>
              a.recordId === this.selectedRecords[0].toString() &&
              a.moduleId === this.moduleId &&
              a.changed === false
          );

          if (openedObject == null) {
            openedObject = {
              moduleId: this.moduleId,
              recordId: this.selectedRecords[0].toString(),
              title: null,
              selected: true,
              moduleFilterId: this.moduleFilterId,
              guid: null,
              changed: false,
              recordModel: undefined,
            };

            this.openedObjects.push(openedObject);
            this.addUpdateRecordModelQueue(openedObject);
          }

          openedObject.title = null;
          openedObject.selected = true;
        }

        this.recordPageInit = true;
      }, 100);
    }
  }

  navigateToNew() {
    this.router.navigate([
      `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
      {
        newMode: true,
      },
    ]);
  }

  recordPageDrawerClosed() {
    this.selectedRecords = [];
    this.router.navigate([
      `${this.urlPrefix}${this.moduleId}/${this.moduleFilterId}`,
    ]);
  }

  recordModelChanged(recordModel: RecordModel) {
    this.recordModel = recordModel;
    const recordDetailsFieldName =
      this.moduleStructure.module.AdditionalInformationParsed
        .RecordDetailsFieldName;

    if (recordDetailsFieldName != null && recordDetailsFieldName !== '') {
      this.objectDescription = recordModel.Categories.find(
        (f) => f.Id === recordDetailsFieldName.split('.')[0]
      ).Lines[0].Properties.find(
        (p) => p.Name === recordDetailsFieldName.split('.')[1]
      ).ValueAsObject;
    } else if (
      recordModel.Categories.find((f) => f.Id === 'Documents') !== undefined
    ) {
      this.objectDescription = recordModel.Categories.find(
        (f) => f.Id === 'Documents'
      ).Lines[0].Properties.find((p) => p.Name === 'DocNum').ValueAsObject;
    } else {
      this.objectDescription = this.selectedRecords[0];
    }

    if (!this.newMode) {
      const objectDesc = `${this.layoutService.translate(
        this.moduleInformation.Name
      )} ${this.objectDescription}`;
      const tab = this.openedObjects.find((a) => a.selected);
      if (tab != null) {
        tab.title = this.objectDescription;
        tab.fullTitle = objectDesc;
        tab.guid = recordModel.FormGUID;
      }

      this.title.setTitle(`${objectDesc} - ${g.getTitleSuffix()}`);
    }
  }

  valueChanged(args: FieldValueChangedArgs) {
    const tab = this.openedObjects.find((a) => a.selected);
    if (args.recordModel.FormGUID !== tab.guid) {
      return;
    }

    tab.recordModel = args.recordModel;
    tab.changed = true;

    this.addUpdateRecordModelQueue(tab);

    if (this.guid !== tab.guid) {
      this.router.navigate([
        `${this.urlPrefix}${tab.moduleId}/${tab.moduleFilterId}`,
        {
          selectedId: tab.recordId,
          guid: tab.guid,
        },
      ]);
    }
  }

  addUpdateRecordModelQueue(tab: RecordModelQueue) {
    setTimeout(() => {
      const transaction = this.db.transaction('RecordModelQueue', 'readwrite');
      const store = transaction.objectStore('RecordModelQueue');
      tab.changed = true;
      store.put(tab);
    }, 0);
  }

  navigateToObj(obj) {
    this.moduleId = obj.moduleId;
    this.router.navigate([
      `${this.urlPrefix}${obj.moduleId}/${obj.moduleFilterId}`,
      {
        selectedId: obj.recordId,
        guid: obj.guid,
      },
    ]);
  }

  deleteObj(obj: RecordModelQueue) {
    const index = this.openedObjects.indexOf(obj);
    this.openedObjects.splice(index, 1);

    if (
      this.moduleId === obj.moduleId &&
      this.selectedRecords[0].toString() === obj.recordModel?.FormGUID
    ) {
      this.router.navigate([
        `${this.urlPrefix}${obj.moduleId}/${obj.moduleFilterId}`,
      ]);
    }

    setTimeout(() => {
      const transaction = this.db.transaction('RecordModelQueue', 'readwrite');
      const store = transaction.objectStore('RecordModelQueue');
      store.delete(obj.guid);
    }, 0);
  }

  pageHeaderAffixChanged(newValue: boolean) {
    this.pageHeaderAffix = newValue;
  }

  objectSubmitted(selectedId: any) {
    if (this.newMode) {
      this.newMode = false;
      this.recordSelected([selectedId]);
    }
  }

  selectRecordFromCheckBoxChanged(event) {
    this.selectedRecordsFromCheckBox = event;
  }
}
